module.exports = __webpack_public_path__ + "img/pencil-light.67a7865c.png";